export const QUICK_CHECKOUT_ACTIVATED_FLAG_NAME = 'quickCheckoutActivated';
export const QUICK_CHECKOUT_WITHOUT_RECOVERY_FLAG_NAME = 'quickCheckoutWithoutRecovery';
export const QUICK_CHECKOUT_INITIALIZED = 'QuickCheckoutInitialized';
export const HTO_ITEMS_IDS = 'HTO_items_ids';
